export default function LoadingScreen() {
  return <div className="min-h-screen" aria-hidden="true" />;
}
